import React from 'react';
import { Container, Card } from 'react-bootstrap';
import logo from '../../assets/Logo_EssilorLuxottica_black.png';
import './Login.css';


interface LoginProps {
    onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
    return (
        <Container className="login-container">
            <Card className="login-box">
                <img className="el-logo el-logo-login" src={logo} alt="Logo" />
                <h2 className="py-1 h-login" style={{ pointerEvents: 'none' }}>The Hub</h2>
                <button className="btn btn-primary btn-login" onClick={onLogin}>
                    Enter
                </button>
            </Card>
        </Container>
    );
};

export default Login;
